import { createRouter, createWebHistory } from "vue-router";
import PolicyPage from "../pages/PolicyPage.vue";
import OptionalRule from "../pages/rules/OptionalRule.vue";
import QrcodeGroup from "../pages/QrcodeGroup.vue";
import DownloadGuidance from "../pages/DownloadGuidance.vue";
import OpenMiniProgram from "../pages/OpenMiniProgram.vue";
import WriteOffRule from "../pages/WriteOffRule.vue";
import PrivacyPolicyAndTerms from "../pages/PrivacyPolicyAndTerms.vue";
import ConsultDetail from "../pages/ConsultDetail.vue";
import MessageDetail from "../pages/MessageDetail.vue";
import WriteOffRuleNative from "../pages/WriteOffRuleNative.vue";
import WriteOffRuleNativeNew from "../pages/WriteOffRuleNativeNew.vue";
import ActivityPage0727 from "../pages/ActivityPage0727.vue";
import NeteaseActivity from "../pages/netease/NeteaseActivity.vue";
import NeteaseHistory from "../pages/netease/NeteaseHistory.vue";
import FAQ from "../pages/FAQ.vue";
import FAQ2 from "../pages/FAQ2.vue";
import CarRental from "../pages/sdk/carrental.vue";
import CarRentalSuccess from "../pages/sdk/success.vue";
import UnavailableCity from "../pages/sdk/UnavailableCity.vue";
import CarrentalConsulting from "../pages/sdk/consulting.vue";
import UdpIndex from "../pages/udp/index.vue";
import CouponPackage from '../pages/couponPackage/index.vue'
import DriveBenefit from '../pages/driveBenefit/index.vue'
import ActivityCoupon from '../pages/activityCoupon/index.vue'

const routes = [
  {
    // 协议详情
    path: "/policy/:id",
    name: "PolicyPage",
    component: PolicyPage,
  },
  {
    // 协议详情(无需token)
    path: "/policy/public/:id",
    name: "PolicyPagePublic",
    component: PolicyPage,
  },
  {
    // app内嵌规则页
    path: "/rules/optional",
    name: "OptionalRule",
    component: OptionalRule,
  },
  {
    // 活动页: 扫码下载
    path: "/campaign/zs001",
    name: "QrcodeGroup",
    component: QrcodeGroup,
  },
  {
    // 极氪订阅下载页
    path: "/download",
    name: "DownloadGuidance",
    component: DownloadGuidance,
    meta: {
      title: "下载",
    },
  },
  {
    // 极氪订阅下载页
    path: "/openMiniProgram",
    name: "openMiniProgram",
    component: OpenMiniProgram,
    meta: {
      title: "打开小程序",
    },
  },
  {
    // 注销风险说明
    path: "/writeoffrule",
    name: "WriteOffRule",
    component: WriteOffRule,
    meta: {
      title: "注销风险说明",
    },
  },
  {
    // 注销风险说明-专供ios使用
    path: "/writeOffrulenative",
    name: "WriteOffRuleNative",
    component: WriteOffRuleNative,
    meta: {
      title: "申请注销",
    },
  },
  {
    // 注销风险说明-专供ios使用
    path: "/WriteOffRuleNativeNew",
    name: "WriteOffRuleNativeNew",
    component: WriteOffRuleNativeNew,
    meta: {
      title: "申请注销",
    },
  },
  {
    // 隐私政策及条款
    path: "/privacypolicyandterms",
    name: "PrivacyPolicyAndTerms",
    component: PrivacyPolicyAndTerms,
    meta: {
      title: "隐私",
    },
  },
  {
    // 资讯详情
    path: "/consultdetail",
    name: "ConsultDetail",
    component: ConsultDetail,
    meta: {
      title: "资讯详情",
    },
  },
  {
    // 消息详情
    path: "/messagedetail",
    name: "MessageDetail",
    component: MessageDetail,
    meta: {
      title: "消息详情",
    },
  },
  {
    // 七夕约会满分秘籍
    path: "/activity0727",
    name: "ActivityPage0727",
    component: ActivityPage0727,
    meta: {
      title: "七夕约会满分秘籍",
    },
  },
  {
    // 极氪订阅x网易严选
    path: "/NeteaseActivity",
    name: "NeteaseActivity",
    component: NeteaseActivity,
    meta: {
      title: "极氪订阅x网易严选",
      keepAlive: true,
    },
  },
  {
    // 网易领取历史
    path: "/NeteaseHistory",
    name: "NeteaseHistory",
    component: NeteaseHistory,
    meta: {
      title: "我的特权",
    },
  },
  {
    // 常见问题
    path: "/FAQ",
    name: "FAQ",
    component: FAQ,
    meta: {
      title: "常见问题",
    },
  },
  {
    // 订阅指南
    path: "/FAQ2",
    name: "FAQ2",
    component: FAQ2,
    meta: {
      title: "订阅指南",
    },
  },
  {
    // 常见问题
    path: "/sdk/carrental",
    name: "CarRental",
    component: CarRental,
    meta: {
      title: "订阅",
    },
  },
  {
    // 常见问题成功提示
    path: "/sdk/CarRentalSuccess",
    name: "CarRentalSuccess",
    component: CarRentalSuccess,
    meta: {
      title: "订阅",
    },
  },
  {
    // sdk不可用城市
    path: "/sdk/UnavailableCity",
    name: "UnavailableCity",
    component: UnavailableCity,
    meta: {
      title: "极氪订阅",
    },
  },
  {
    // 二维码页
    path: "/sdk/Consulting",
    name: "CarrentalConsulting",
    component: CarrentalConsulting,
    meta: {
      title: "订阅咨询",
    },
  },
  {
    // udp
    path: "/udp",
    name: "udp",
    component: UdpIndex,
    meta: {
      title: "极氪订阅",
    },
  },
  {
    // udp
    path: "/couponPackage",
    name: "couponPackage",
    component: CouponPackage,
    meta: {
      title: "购省钱套餐卡，至高可省8500元",
    },
  },
  {
    path: "/driveBenefit",
    name: "driveBenefit",
    component: DriveBenefit,
    meta: {
      title: "订阅出行权益",
    },
  },
  {
    path: "/activityCoupon",
    name: "activityCoupon",
    component: ActivityCoupon,
    meta: {
      title: " ",
    },
  },
];
export default createRouter({
  history: createWebHistory(),
  routes: routes,
});
